import newOnboarding from '~/pages/Onboarding/store/onboarding.sagas';
import storeConnect from '~/pages/StoreConnections/store/store-connect.sagas';
import { all } from 'redux-saga/effects';
import abTest from './ab-test';
import address from './address';
import analytics from './analytics';
import apps from './apps';
import auth from './auth';
import automations from './automations';
import billing from './billing';
import carrierAccounts from './carrier-accounts';
import carrierFormFields from './carrier-form-fields';
import carrierFormInput from './carrier-form-input';
import csvImport from './csv-import';
import customs from './customs';
import featureTests from './feature-tests';
import filters from './filters';
import gtm from './gtm';
import initializers from './initializers';
import invoiceItems from './invoice-items';
import invoices from './invoices';
import item from './item';
import labelsSettings from './labels-settings';
import lineItem from './line-item';
import login from './login';
import manifests from './manifests';
import manualOrder from './manual-order';
import notifications from './notifications';
import orders from './orders';
import ordersBatch from './orders-batch';
import packages from './packages';
import parcelTemplate from './parcel-template';
import pendingInvoiceTransactions from './pending-invoice-transactions';
import pickups from './pickups';
import plans from './plans';
import prodAnalytics from './prod-analytics';
import promos from './promos';
import providers from './providers';
import ratesAtCheckoutSagas from './rates-at-checkout';
import routing from './routing';
import segment from './segment';
import shipments from './shipments';
import shippingMethods from './shipping-methods';
import stores from './stores';
import stripe from './stripe';
import token from './token';
import trackingSettings from './tracking-settings';
import transactions from './transactions';
import user from './user';
import userTracking from './user-tracking';
import versioning from './versioning';
import webhooks from './webhooks';

export default function* rootSaga() {
  yield all([
    ...initializers,
    ...user,
    ...address,
    ...auth,
    ...csvImport,
    ...orders,
    ...shipments,
    ...parcelTemplate,
    ...ordersBatch,
    ...abTest,
    ...transactions,
    ...promos,
    ...pickups,
    ...routing,
    ...stores,
    ...providers,
    ...labelsSettings,
    ...notifications,
    ...filters,
    ...packages,
    ...featureTests,
    ...shippingMethods,
    ...gtm,
    ...analytics,
    ...plans,
    ...automations,
    ...stripe,
    ...carrierAccounts,
    ...carrierFormFields,
    ...carrierFormInput,
    ...userTracking,
    ...lineItem,
    ...login,
    ...prodAnalytics,
    ...customs,
    ...manualOrder,
    ...invoices,
    ...invoiceItems,
    ...billing,
    ...pendingInvoiceTransactions,
    ...ratesAtCheckoutSagas,
    ...manifests,
    ...newOnboarding,
    ...trackingSettings,
    ...token,
    ...webhooks,
    ...versioning,
    ...segment,
    ...apps,
    ...storeConnect,
    ...item,
  ]);
}
